import { logger } from '@damofire/data-commons';
import { Inject, Injectable, OnDestroy } from '@angular/core';
import { Observable, ReplaySubject, Subject, Subscription } from 'rxjs';
import { WarehouseSyncEvent } from '../des.dto';
import { concatMap, filter } from 'rxjs/operators';
import { OutputSyncService } from './output-sync.service';
import { WarehouseSyncStepContextEvent } from './executors';
import { COMMONS_ENV } from '@damofire/data-angular-commons';

@Injectable()
export class WarehouseSyncEventService implements OnDestroy {
  private readonly _outputChannel: Subject<WarehouseSyncEvent> = new Subject<WarehouseSyncEvent>();
  private readonly outputSub: Subscription;
  private _syncStatus: ReplaySubject<WarehouseSyncStepContextEvent>;
  private division: string;

  constructor(
    private readonly outputSyncService: OutputSyncService,
    @Inject(COMMONS_ENV) private readonly environment: any,
  ) {
    this.outputSub = this._outputChannel.pipe(concatMap((event: WarehouseSyncEvent) => outputSyncService.handleOutputChanges(event))).subscribe();
  }

  ngOnDestroy(): void {
    this.outputSub.unsubscribe();
    this._outputChannel.complete();
    this._syncStatus?.complete();
  }

  publishOutput(e: WarehouseSyncEvent): void {
    this._outputChannel.next(e);
  }

  watchOutput(division: string): Observable<WarehouseSyncEvent> {
    return this._outputChannel.pipe(filter((e) => e.division === division));
  }

  publishSyncStatus(e: WarehouseSyncStepContextEvent): void {
    const status = this.prepareForDivision(e.ctx.division);
    status.next(e);
  }

  watchInputStatus(division: string): Observable<WarehouseSyncStepContextEvent> {
    return this.prepareForDivision(division);
  }

  onSyncFinished(division: string): Observable<WarehouseSyncStepContextEvent> {
    return this.watchInputStatus(division).pipe(filter((e) => e.event === 'SYNC_FINISHED' || e.event === 'SYNC_CANCELLED'));
  }

  private prepareForDivision(division: string): ReplaySubject<WarehouseSyncStepContextEvent> {
    if (division !== this.division) {
      logger.info('WarehouseSyncEventService - Warehouse changed, resetting event history.', { previousDivision: this.division, newDivision: division, category: 'sync' });
      this._syncStatus?.complete();
      this._syncStatus = new ReplaySubject<WarehouseSyncStepContextEvent>(this.environment.appConfig.watson.maxSyncEventReplay);
      this.division = division;
    }

    return this._syncStatus;
  }
}
